import React from "react";
import { List } from "@mui/material";
import { OrderRow } from "@features/orders-features/types/types";
import Order from "./Order";
import { OrderViewType } from "../types/OrderViewType";
import NoOrderContent from "@widgets/ecommerce/Components/NoOrderContent";

export interface OrderListProps {
  orders?: OrderRow[];
  type: OrderViewType;
}

export default function OrderList({ orders, type }: Readonly<OrderListProps>) {
  if (!orders?.length) {
    return (<NoOrderContent />);
  }

  return (
    <List disablePadding aria-label="Recent orders list">
      {orders.map((order, index) => (
        <Order
          key={`${index}|${order.id}`}
          order={order}
          type={type}
        />
      ))}
    </List>
  );
}
